
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.083 1.667H2.917a1.25 1.25 0 0 0-1.25 1.25v14.167a1.25 1.25 0 0 0 1.25 1.25h14.166a1.25 1.25 0 0 0 1.25-1.25V2.917a1.25 1.25 0 0 0-1.25-1.25ZM6.667 15.834h-2.5v-7.5h2.5v7.5Zm-1.25-8.959a1.458 1.458 0 1 1 1.5-1.458 1.483 1.483 0 0 1-1.5 1.458Zm10.416 8.959h-2.5v-3.95c0-1.184-.5-1.609-1.15-1.609a1.45 1.45 0 0 0-1.35 1.55.555.555 0 0 0 0 .117v3.892h-2.5v-7.5h2.417v1.083A2.592 2.592 0 0 1 13 8.25c1.292 0 2.8.717 2.8 3.05l.033 4.534Z","fill":"#fff"}})])
          )
        }
      }
    